import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { SwipeTranslationSchema } from './swipe';
import { SimpleSignupTranslationSchema } from './simple-signup';

//Each bodyCopy object in the array corresponds to one paragraph in the email body text
export type BodyCopy = Static<typeof BodyCopySchema>;
export const BodyCopySchema = Type.Object(
  {
    bodyCopy: Type.String({ minLength: 1, maxLength: 1500 }),
  },
  { additionalProperties: false, $id: 'bodyCopySchema' }
);

export type WinnerEmailTranslation = Static<typeof WinnerEmailTranslationSchema>;
export const WinnerEmailTranslationSchema = Type.Object(
  {
    winner: Type.Object({
      subjectLine: Type.String({ minLength: 1, maxLength: 100 }),
      preHeader: Type.String({ minLength: 1, maxLength: 50 }),
      bodyHeadline: Type.String({ minLength: 1, maxLength: 100 }),
      ctaText: Type.Optional(Type.String({ minLength: 1, maxLength: 50 })),
      ctaLink: Type.Optional(Type.String({ format: 'uri', maxLength: 1000 })),
      disclaimerText: Type.String({ minLength: 0, maxLength: 1000 }),
      body: Type.Object({ copy: Type.Array(BodyCopySchema, { minItems: 1, maxItems: 5 }) }),
    }),
  },
  { additionalProperties: false, $id: 'winnerEmailTranslationSchema' }
);

export type ClaimMyPrizeTranslation = Static<typeof ClaimMyPrizeTranslationSchema>;
export const ClaimMyPrizeTranslationSchema = Type.Object(
  { termsAndConditions: Type.String({ minLength: 1, maxLength: 350 }) },
  { additionalProperties: false, $id: 'claimMyPrizeTranslationSchema' }
);

export type LegalTranslation = Static<typeof LegalTranslationSchema>;
export const LegalTranslationSchema = Type.Object(
  {
    termsAndConditions: Type.Optional(Type.String({ minLength: 1, maxLength: 1000 })),
    contestRules: Type.Optional(Type.String({ minLength: 1, maxLength: 1000 })),
    privacyPolicy: Type.Optional(Type.String({ minLength: 1, maxLength: 1000 })),
    disclaimerText: Type.Optional(Type.String({ minLength: 1, maxLength: 500 })),
  },
  { additionalProperties: false, $id: 'legalTranslationSchema' }
);

export type Translation = Static<typeof TranslationSchema>;
export const TranslationSchema = Type.Object(
  {
    language: Type.String(),
    email: Type.Optional(WinnerEmailTranslationSchema),
    createdAt: Type.Optional(Type.String({ format: 'date-time' })),
    updatedAt: Type.Optional(Type.String({ format: 'date-time' })),
    swipe: Type.Optional(SwipeTranslationSchema),
    simpleSignup: Type.Optional(SimpleSignupTranslationSchema),
    legal: Type.Optional(LegalTranslationSchema),
  },
  { additionalProperties: false, $id: 'translationSchema' }
);

export type TranslationConfig = Static<typeof TranslationConfigSchema>;
export const TranslationConfigSchema = Type.Record(
  Type.String(),
  Type.Object({
    claimMyPrize: Type.Optional(ClaimMyPrizeTranslationSchema),
    email: Type.Optional(WinnerEmailTranslationSchema),
    swipe: Type.Optional(SwipeTranslationSchema),
    simpleSignup: Type.Optional(SimpleSignupTranslationSchema),
    legal: Type.Optional(LegalTranslationSchema),
  }),
  { additionalProperties: false, $id: 'createTranslationSchema' }
);
